import { render, staticRenderFns } from "./Pta.vue?vue&type=template&id=4295b2eb"
import script from "./Pta.vue?vue&type=script&lang=js"
export * from "./Pta.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports